import { kioskFetch } from "./kioskFetch";
const API_BASE = process.env.REACT_APP_IMS_API_BASE_URL || 'http://localhost:4001';
const SALE_PATH = process.env.REACT_APP_SALE_PATH || '/api/pos/sale';

export type ApiPaymentMethod = 'CARD' | 'DEBIT' | 'CASH' | 'STUDENT_CARD' | 'GIFT_CARD';

export interface SaleItem { item_sku: string; qty: number; unit_price?: number; }
export interface SaleRequest {
  location_id: number;
  pos_id: string;
  transaction_number: string;
  payment_method: ApiPaymentMethod;
  items: SaleItem[];
}
export interface SaleResponse { success?: boolean; transaction_id?: string; message?: string; }

export async function postSale(payload: SaleRequest): Promise<SaleResponse> {
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  const res = await kioskFetch(`${API_BASE}${SALE_PATH}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  let json: any = null;
  try { json = await res.clone().json(); } catch {}

  if (!res.ok) {
    const msg = (json && (json.message || json.error)) || `HTTP ${res.status}`;
    throw new Error(`SALE_ERR: ${msg}`);
  }
  return json || {};
}
